<svg
  xmlns="http://www.w3.org/2000/svg"
  width="28"
  height="28"
  class="user-select-none cursor-pointer"
  fill="none"
  viewBox="0 0 26 26">
  <path
    fill="#fff"
    d="M11.204 2.276c.92-.791 2.28-.791 3.201 0a2.457 2.457 0 0 0 2.152.53 2.457
    2.457 0 0 1 2.835 1.488 2.457 2.457 0 0 0 1.66 1.47 2.457 2.457 0 0 1 1.818
    2.634c-.082.777.21 1.546.786 2.073a2.457 2.457 0 0 1 .386 3.178 2.457 2.457
    0 0 0-.267 2.2 2.457 2.457 0 0 1-1.136 2.994 2.457 2.457 0 0 0-1.259 1.824
    2.457 2.457 0 0 1-2.396 2.123c-.78.012-1.51.394-1.963 1.03a2.457 2.457 0 0
    1-3.108.766 2.457 2.457 0 0 0-2.216 0 2.457 2.457 0 0 1-3.109-.766 2.457
    2.457 0 0 0-1.963-1.03 2.457 2.457 0 0 1-2.396-2.123 2.457 2.457 0 0
    0-1.259-1.824 2.457 2.457 0 0 1-1.135-2.994 2.457 2.457 0 0 0-.267-2.2 2.457
    2.457 0 0 1 .386-3.178 2.457 2.457 0 0 0 .785-2.073 2.457 2.457 0 0 1
    1.82-2.634 2.457 2.457 0 0 0 1.658-1.47 2.457 2.457 0 0 1
    2.835-1.488c.76.175 1.56-.022 2.152-.53Z" />
  <circle cx="12.806" cy="13.401" r="8.053" fill="#fff" stroke="#45B36B" />
  <path
    fill="#45B36B"
    d="M12.645 16.9h1.46V9.856H12.64l-1.82 1.265v1.328l1.796-1.24h.03V16.9Z" />
</svg>
